var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import fetch from 'isomorphic-fetch';
import xss from 'xss';

import Wrapper from './components/wrapper';
import MessageList from './components/message-list';
import TextBox from './components/text-box';
import RatingRadio from './components/rating-radio';

// 3 steps:
// - 1) Ask for satisfaction rating
// - 2) Ask for eventual future usage
// - 3) Ask for an optional comment
// Let the user terminate the process and get him back to the chatbot

var Survey = function (_Component) {
  _inherits(Survey, _Component);

  function Survey(props) {
    _classCallCheck(this, Survey);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      loading: false,
      step: 0,
      satisfactionRating: null,
      futureUsage: null,
      optionalComment: null
    };

    _this.myxss = new xss.FilterXSS({
      whiteList: {
        a: ['href']
      }
    });
    return _this;
  }

  Survey.prototype.componentDidMount = function componentDidMount() {
    this.props.addMessage({
      text: 'Vorremmo farti alcune domande'
    });

    this.nextStep({ step: 1 });
  };

  Survey.prototype.nextStep = function nextStep(newState) {
    var _this2 = this;

    newState = _extends({}, this.state, newState);
    if (newState.step === this.state.step) return this.setState(newState);

    switch (newState.step) {
      case 1:
        {
          this.props.addMessage({
            text: 'Come valuti la sessione di chat appena conclusa con il nostro servizio di assistenza?',
            component: {
              type: RatingRadio,
              props: {
                selected: function selected() {
                  return _this2.state.satisfactionRating;
                },
                handleChange: function handleChange() {
                  return _this2.handleRatingChange.bind(_this2);
                }
              }
            }
          });
          break;
        }
      case 2:
        {
          this.props.addMessage({
            text: 'Utilizzerai ancora la chat in futuro?',
            actions: [{
              text: 'Si',
              onClick: function onClick() {
                return _this2.nextStep({
                  futureUsage: true,
                  step: newState.step === 2 ? 3 : newState.step
                });
              }
            }, {
              text: 'No',
              onClick: function onClick() {
                return _this2.nextStep({
                  futureUsage: false,
                  step: newState.step === 2 ? 3 : newState.step
                });
              }
            }]
          });
          break;
        }
      case 3:
        {
          this.props.addMessage({
            text: 'Lascia un commento'
          });
          break;
        }
      case 4:
        {
          this.props.addMessage({
            text: 'Grazie per la collaborazione!\n\nLa tua opinione è molto importante per permetterci di migliorare la qualità del nostro servizio'
          });
          this.sendSurveyResult(newState);
          this.props.switchToChatBot();
          break;
        }
      default:
        {
          this.props.addMessage({
            text: 'Si è verificato un problema durante l\'acquisizione dei dati',
            user: 'ERROR'
          });
          this.sendSurveyResult(newState);
        }
    }

    this.setState(newState);
  };

  Survey.prototype.handleRatingChange = function handleRatingChange(value) {
    var newState = {
      step: this.state.step === 1 ? 2 : this.state.step,
      satisfactionRating: value
    };
    this.nextStep(newState);
  };

  Survey.prototype.handleQuestion = function handleQuestion(event) {
    if (event.key === 'Enter') {
      if (event.target.value === '') {
        return;
      }

      var question = this.myxss.process(event.target.value);
      this.props.addMessage({ text: question, user: 'CUSTOMER' });

      event.target.value = '';

      if (this.state.step === 3) {
        this.nextStep({
          optionalComment: question,
          step: 4
        });
      }
    }
  };

  Survey.prototype.sendSurveyResult = function sendSurveyResult(_ref) {
    var _this3 = this;

    var satisfactionRating = _ref.satisfactionRating,
        futureUsage = _ref.futureUsage,
        optionalComment = _ref.optionalComment;

    var surveyData = {
      '3_2': satisfactionRating,
      '3_3': futureUsage ? 7 : 8,
      '1_4_9': optionalComment,
      command: 'submitPoll'
    };

    this.setState({
      loading: true
    });

    fetch(this.props.chatURL + 'sondaggio.jsp', {
      method: 'POST',
      body: JSON.stringify(surveyData),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).catch(function () {
      _this3.props.addMessage({
        text: 'Si è verificato un problema durante l\'acquisizione dei dati',
        user: 'ERROR'
      });
    });
  };

  Survey.prototype.render = function render() {
    return React.createElement(
      Wrapper,
      null,
      this.props.children,
      React.createElement(MessageList, {
        messages: this.props.messages,
        loading: this.state.loading
      }),
      React.createElement(TextBox, {
        loading: this.state.loading,
        onKeyPress: this.handleQuestion.bind(this)
      })
    );
  };

  return Survey;
}(Component);

export { Survey as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/@hype/chatbot/es/survey.js
// module id = 891
// module chunks = 1